import React from 'react';
import PropTypes from 'prop-types';

const Label = ( {value} ) => (
    !!value && <span className="goal-label-text" dangerouslySetInnerHTML={ { __html: `&nbsp;${value}&nbsp;` } }/>
);
Label.propTypes = { value: PropTypes.string };

export default Label;
